export const prettyCurrency = (value) => {
  if (value) {
    return value
      .toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      })
      .split('.')[0];
  } else {
    return '$0';
  }
};

export const formatPhoneNumber = (phoneNumberString) => {
  let number = phoneNumberString;
  if (typeof number === 'number') {
    number = phoneNumberString.toString();
  }
  let cleaned = ('' + number).replace(/\D/g, '');
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    let intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return phoneNumberString;
};

export const formatToPhoneNumber = (str = '') => {
  let returnStr = '';
  const input = str.replace(/\D/g, '').substring(0, 10); // First ten digits of input only
  const zip = input.substring(0, 3);
  const middle = input.substring(3, 6);
  const last = input.substring(6, 10);
  if (input.length > 6) {
    returnStr = `(${zip}) ${middle}-${last}`;
  } else if (input.length > 3) {
    returnStr = `(${zip}) ${middle}`;
  } else if (input.length > 0) {
    returnStr = `(${zip}`;
  }
  return returnStr;
};

export const secondsToHms = (d) => {
  d = Number(d);
  let h = Math.floor(d / 3600);
  let m = Math.floor((d % 3600) / 60);
  let s = Math.floor((d % 3600) % 60);

  let hDisplay = h > 0 ? h + (h === 1 ? ' hour, ' : ' hours, ') : '';
  let mDisplay = m > 0 ? m + (m === 1 ? ' minute, ' : ' minutes, ') : '';
  let sDisplay = s > 0 ? s + (s === 1 ? ' second' : ' seconds') : '';
  return String(hDisplay + mDisplay + sDisplay)
    .trim()
    .replace(/,$/, '');
};

export const changePercentDifference = (thisValue, previousValue) => {
  const difference = thisValue - previousValue;
  if (parseInt(previousValue, 0) === 0) {
    return '100%';
  }
  return Math.abs(((difference / previousValue) * 100).toFixed(0).toString()) + '%';
};

export const getHumanReadableTime = (timeInSeconds) => {
  let time = '';
  const minutes = timeInSeconds / 60;
  const remainingSeconds = Math.round((minutes % 1) * 60);

  time += `${Math.floor(minutes)}m`;

  if (remainingSeconds === 0) return time;

  time += ` ${remainingSeconds}s`;

  return time;
};
